export default "__VITE_PUBLIC_ASSET__6afb6c2b__"